/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Nativelanguage_Suedliches_Sotho3Inputs */

const en__field__enum_nativelanguage_suedliches_sotho3 = /** @type {(inputs: _Field__Enum_Nativelanguage_Suedliches_Sotho3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suedliches_Sotho`)
};

const de__field__enum_nativelanguage_suedliches_sotho3 = /** @type {(inputs: _Field__Enum_Nativelanguage_Suedliches_Sotho3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suedliches_Sotho`)
};

/**
* | output |
* | --- |
* | "Suedliches_Sotho" |
*
* @param {_Field__Enum_Nativelanguage_Suedliches_Sotho3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_nativelanguage_suedliches_sotho3 = /** @type {((inputs?: _Field__Enum_Nativelanguage_Suedliches_Sotho3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Nativelanguage_Suedliches_Sotho3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_nativelanguage_suedliches_sotho3(inputs)
	return de__field__enum_nativelanguage_suedliches_sotho3(inputs)
});
export { _field__enum_nativelanguage_suedliches_sotho3 as "_field__enum_nativeLanguage_Suedliches_Sotho" }